import { render, staticRenderFns } from "./BankCreateView.vue?vue&type=template&id=695a6bd5&scoped=true"
import script from "./BankCreateView.vue?vue&type=script&lang=js"
export * from "./BankCreateView.vue?vue&type=script&lang=js"
import style0 from "./BankCreateView.vue?vue&type=style&index=0&id=695a6bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a6bd5",
  null
  
)

export default component.exports